export default {
      id: "regional_admin-usage",
      viewBox: "0 0 69.97 69.97",
      url: __webpack_public_path__ + "sprite.svg#regional_admin",
      toString: function () {
        return this.url;
      }
    }